module.exports = __webpack_public_path__ + "images/mic-infinitya02e0d2b94b41fd56566791bb5648659.gif";